// extracted by mini-css-extract-plugin
export var readonly = "_e1-1";
export var star = "_e1-0";